import BudgetSystemRepository from '@/shared/http/repositories/configuration/budgetsystem'
import { mutationTypes as mutation } from './mutations'
import store from '@/store/'

const MODULE_NAME = 'budgetsystem/budgetsystems'
const GET_BY_ID = 'getBudgetSystemById'
const GET_ALL = 'getAllBudgetSystems'

export const actionTypes = {
  GET_BY_ID,
  GET_ALL
}

export const actions = {
  [GET_BY_ID] ({ commit }, payload) {
    commit(mutation.SET_BUDGETSYSTEM, payload)
  },

  async [GET_ALL] ({ commit }, forceReload) {
    if (store.getters[MODULE_NAME].length === 0 || (forceReload)) {
      BudgetSystemRepository.GetAll()
        .then((res) => {
          commit(mutation.SET_BUDGETSYSTEMS, res.data)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/budgetsystem/actions.js